import React from 'react';

import TextareaAutoresize from 'react-textarea-autosize';

import { useField } from 'formik';

import classNames from 'classnames';

import './index.scss';

const MutateTipPionContent = ({ name, ...props }) => {
  const [field, fieldMeta] = useField(name);

  return (
    <TextareaAutoresize
      {...props}
      {...field}
      className={classNames(
        'mutate-tip-pion-content',
        { 'mutate-tip-pion-content-error': fieldMeta.error },
        props.className,
      )}
      placeholder="Content"
    />
  );
};

export default MutateTipPionContent;
